import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="terms-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="terms-header">
          <h2>Terms & Conditions</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="terms-content">
          <section>
            <h3>Website Content Accuracy</h3>
            <p>
              While we exercise due diligence in creating our brochures, pricing information, website content, and promotional materials, we cannot guarantee complete accuracy and are not responsible for typographical or printing mistakes.
            </p>
            <p>
              Our marketing materials may be produced well in advance of your travel dates, and information contained within may become outdated. We encourage you to verify current details by reaching out to our team directly.
            </p>
            <p>
              Travel schedules are subject to variation. Featured products and services may be modified. Images of dining experiences and attractions serve as examples only and actual offerings may differ. Travel distances and weather conditions are estimations that may vary based on route selection, road infrastructure, and seasonal climate patterns.
            </p>
          </section>

          <section>
            <h3>Travel Plan Modifications</h3>
            <p>
              Kalyan Travels maintains the authority to adjust, modify, or restructure travel packages and schedules both prior to and throughout your journey. We commit to providing reasonable advance notification of such adjustments during the booking process or before departure. Should modifications become necessary during your trip, our tour coordinator or local representative will communicate these changes directly, and we appreciate your understanding and flexibility.
            </p>
            <p>
              Consequently, complaints concerning schedule or service modifications that we are compelled to implement will not be considered from travelers during or following the completion of your tour. Special promotional packages may carry additional stipulations beyond these standard conditions, including specific deposit requirements, payment schedules, deadlines, and payment methods that supplement these general terms.
            </p>
            <p>
              Adjustments may become unavoidable due to circumstances outside our direct influence, including but not limited to natural disasters, labor strikes, cultural festivals, sporting competitions, adverse weather, transportation delays, accommodation overbooking, flight modifications or rerouting, train schedule changes, or restricted access to tourist sites. We generally avoid scheduling during major exhibitions and events when accommodations are reserved years in advance. If travel during such periods is necessary, alternative lodging arrangements or accommodations in nearby areas may be required.
            </p>
            <p>
              Aviation regulations may necessitate changes to arrival and departure points within destinations. We may operate multiple coaches for the same departure date and may, for operational efficiency, reverse routing or adjust the schedule.
            </p>
            <p>
              Schedule modifications may also become necessary due to the conduct, negligence, or circumstances of fellow travelers.
            </p>
            <p>
              We strive to maintain the overall value and quality of your travel experience. However, we cannot provide refunds or compensation for necessary itinerary adjustments.
            </p>
            <p>
              When alternative arrangements exceed the quality of originally planned services as described in our materials, additional charges may apply and will be communicated at booking or during travel.
            </p>
          </section>

          <section>
            <h3>Travel Services and Coverage</h3>
            <p>
              The extent of included services is clearly outlined in our quotations, general catalog information, and travel confirmation documentation.
            </p>
          </section>

          <section>
            <h3>Service Delivery and Pricing Adjustments</h3>
            <p>
              Modifications to individual travel components that deviate from the original contract terms, when required post-agreement and implemented in good faith, are permissible provided such changes are minor and do not significantly impact the overall travel experience. Quality assurance claims remain valid for any modified services that fail to meet standards.
            </p>
            <p>
              We will promptly communicate any changes or variations to your designated booking agent. When possible, we offer complimentary rebooking or cancellation options. Significant currency fluctuations or fuel cost increases, particularly affecting air travel, may require fare adjustments when more than four months separate tour confirmation from departure.
            </p>
            <p>
              Price increase notifications will be provided immediately but no later than 21 days before departure, after which no further increases are permitted. For price increases exceeding 5% of the total cost, you may withdraw from the contract without penalty within 10 days of notification.
            </p>
          </section>

          <section>
            <h3>Reservation Process</h3>
            <p>
              Booking confirmation requires an initial deposit of 50% of the total tour cost. The remaining balance must be settled 10 days prior to tour commencement.
            </p>
            <p>
              We recommend verifying that you possess or can obtain all necessary travel documentation before making your reservation. Please review our website or consult with our staff regarding required paperwork and documentation.
            </p>
          </section>

          <section>
            <h3>Travel Documentation, Entry Requirements, Customs, Currency, and Health Guidelines</h3>
            <p>
              We provide essential regulatory information before your departure. While we may assist with visa application processes when requested, we are not liable for delays in documentation processing unless directly caused by our negligence. Travelers are responsible for ensuring compliance with all relevant travel requirements. Any complications or additional costs resulting from non-compliance are the traveler's responsibility, except in cases of incorrect information provided by our team.
            </p>
          </section>

          <section>
            <h3>Additional Services Not Covered in Base Pricing</h3>
            <p>
              <strong>Air Transportation</strong> Unless specifically stated in the travel description, international and domestic airfare is not included in the package price. We are happy to arrange flight bookings upon request.
            </p>
            <p>
              <strong>Individual Room Accommodation</strong> Most Indian hotels operate with double-occupancy rooms as standard. Single room arrangements are available with applicable surcharges as detailed in our pricing schedule.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;